import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { Form } from 'semantic-ui-react'

import { loadSubgenres } from '../Slice/SubgenreSlice'

export default function SearchSubgenre ({
  name = 'subgenres',
  icon = 'search',
  multiple = true,
  value,
  onChange,
  size = 7
}) {
  const dispatch = useDispatch()
  const { isLoading, list } = useSelector(state => state.subgenre)
  const { t } = useTranslation()

  useEffect(() => {
    dispatch(loadSubgenres({ limit: 100 }))
  }, [])

  const onDropdownChange = (e, data) => {
    if (typeof onChange === 'function') {
      onChange(e, data)
    }
  }

  return (
    <Form.Dropdown
      fluid
      icon={icon}
      label={t('subgenre.title')}
      loading={isLoading}
      multiple={multiple}
      name={name}
      options={list.length > 0 ? list.map((element) => ({
        key: element.id,
        text: element.name,
        value: element.id
      })) : []}
      placeholder={t('subgenre.search')}
      search
      selection
      value={value}
      width={size}
      onChange={onDropdownChange}
    />
  )
}
